module.exports = {
    blog_title:'Taption 资讯专区',
    blog_desc:'提供相关文章，产品细节给创作者。也能在这里找到Taption相关更新，新闻等资讯',
    written_by: '作者', 
}